<template>
  <v-data-table
    :headers="headers"
    :items="equipments"
    sort-by="model"
    class="elevation-1"
    hide-default-footer
  >
    <template v-slot:top>
      <v-toolbar
        flat
        color="accent"
      >
        <v-toolbar-title class="white--text">Equipment</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
          scrollable
        >
          <v-card>
            <v-card-title class="primary">
              <span class="title text-uppercase white--text">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="editedItem.manufacturer"
                      label="Manufacturer"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="editedItem.model"
                      label="Model"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="editedItem.date_installed"
                            label="Date Installed"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="editedItem.date_installed"
                        @input="menu = false"
                        ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      v-model="editedItem.serial"
                      label="Serial #"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      v-model="editedItem.qty"
                      label="Quantity"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-textarea
                      v-model="editedItem.comment"
                      label="Comment"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions class="grey lighten-3">
              <v-btn
                large min-width="49%" color="blue darken-1" text
                @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                large min-width="49%" color="primary" tile
                @click="save"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="title justify-center">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
    export default {
        data: () => ({
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Manufacturer', value: 'manufacturer', sortable: false },
                {
                  text: 'Model',
                  align: 'start',
                  sortable: false,
                  value: 'model',
                },
                { text: 'Date Installed', value: 'date_installed', sortable: false },
                { text: 'Serial #', value: 'serial', sortable: false },
                { text: 'Quantity', value: 'qty', sortable: false },
            ],
            equipments: [],
            editedIndex: -1,
            editedItem: {
                model: '',
                manufacturer: '',
                date_installed: new Date().toISOString().substr(0, 10),
                serial: '',
                qty: '',
                comment: ''
            },
            defaultItem: {
                model: '',
                manufacturer: '',
                date_installed: new Date().toISOString().substr(0, 10),
                serial: '',
                qty: '',
                comment: ''
            },
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Equipment' : 'Edit Equipment'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        created () {
            this.initialize()
        },

        methods: {
            initialize () {
                this.equipments = [
                    {
                        model: '12345',
                        manufacturer: 'Kaser',
                        date_installed: new Date().toISOString().substr(0, 10),
                        serial: '4125542',
                        qty: 2,
                        comment: 'Test'
                    },
                    {
                        model: '2132123',
                        manufacturer: 'Kaser 2',
                        date_installed: new Date().toISOString().substr(0, 10),
                        serial: '4125542',
                        qty: 2,
                        comment: 'Test'
                    },
                ]
            },

            editItem (item) {
                this.editedIndex = this.equipments.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                this.editedIndex = this.equipments.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.equipments.splice(this.editedIndex, 1)
                this.closeDelete()
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            save () {
                if (this.editedIndex > -1) {
                Object.assign(this.equipments[this.editedIndex], this.editedItem)
                } else {
                this.equipments.push(this.editedItem)
                }
                this.close()
            },
        },
    }
</script>